export default __webpack_public_path__ + "static/media/B635F02F-00.f3d99ed3.png";